import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

/**
 * Crash reporting for the admin site. Off without a DSN (local dev). Nothing personal leaves the browser:
 * no request bodies, headers, cookies or query strings, no form contents, and the user is never identified.
 */
export function initSentry() {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_APP_ENV as string | undefined) ?? "production",
    release: import.meta.env.VITE_RELEASE as string | undefined,
    dataCollection: { userInfo: false, cookies: false, httpHeaders: false, httpBodies: [], urlQueryParams: false },
    tracesSampleRate: 0,
    beforeBreadcrumb: (b) => {
      if (b.category === "console" || b.category === "ui.input") return null;
      if (typeof b.data?.url === "string") b.data.url = b.data.url.split("?")[0];
      return b;
    },
    beforeSend: (event) => {
      if (event.request?.url) event.request.url = event.request.url.split("?")[0];
      delete event.request?.query_string;
      delete event.user;
      return event;
    },
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
